import {useErrorsServiceToken, useLoggerServiceToken} from '@/di/di.root-container.hooks';

import {FC, useEffect, useMemo, useState} from 'react';

import {HttpError} from '@specials/project-user';

import {useLogoutOnBeforeUnload} from '@/hooks/useLogoutOnBeforeUnload';
import {
  ErrorButton,
  ErrorCode,
  ErrorRequestId,
  ErrorSubTitle,
  ErrorTimestamp,
  ErrorTitle,
} from '@/ui/common/AppError/components';
import {UIErrorComponent} from '@/ui/common/AppError/components/constants';

import s from './AppErrorContent.module.css';

export interface Props {
  error: HttpError | unknown;
  errorComponent: UIErrorComponent;
}

export const AppErrorContent: FC<Props> = ({error, errorComponent}) => {
  const [isLoading, setIsLoading] = useState(false);
  const errorsService = useErrorsServiceToken();
  const loggerService = useLoggerServiceToken();

  const errorData = useMemo(() => errorsService.buildErrorData(error), [error]);

  const {title, buttonText, text, action} = errorData.resources;
  const {errorCode, requestId, timestamp} = errorData.breadcrumbs;

  const onButtonClick = async (): Promise<void> => {
    if (!action) return;

    setIsLoading(true);
    try {
      await errorsService.handleErrorAction(action);
    } finally {
      setIsLoading(false);
    }
  };

  useLogoutOnBeforeUnload(action);

  useEffect(() => {
    if (typeof error !== 'undefined' && error !== null) {
      loggerService.logDisplayErrorUIComponent(error, errorData.breadcrumbs, errorComponent);
    }
  }, []);

  return (
    <>
      <ErrorTitle title={title} />
      <ErrorSubTitle text={text} />

      <div className={s.content}>
        <ErrorCode errorCode={errorCode} requestId={requestId} error={error} />
        <ErrorRequestId requestId={requestId} error={error} />
        <ErrorTimestamp timestamp={timestamp} />
      </div>
      {/* так как в ресурсах мы не добавляем buttonText в объект если он не нужен, а в компоненте prop required */}
      <ErrorButton isDisabled={isLoading} buttonText={buttonText || ''} onClick={onButtonClick} />
    </>
  );
};
